import React from 'react';
import { instanceOf } from 'prop-types';
import * as types from '../../actions/actionTypes';
import { useDispatch } from '../../components/common/react-redux-hooks';
import { getUploadedDocuments } from '../../actions/contractAdminActions';
import moment from 'moment';

const CAContractsList = props => {
  const dispatch = useDispatch();
  const editContract = (item, index, section) => {
    props.setEditData(item, index, section);
    dispatch({
      type: types.SET_SELECTED_CONTRACT_ID,
      payload: item.contractId,
    });

    // setSelectedIndex(index);
  };

  const viewDocument = item => {
    dispatch(getUploadedDocuments(item)).then(response => {
      window.open(response.config.url, '_blank');
    });
  };

  return (
    <div>
      <div className="ca-add-contract-List-heading">
        Contract List (within Account)
      </div>
      <div className="contractList-header">
        <span>Contract Name &nbsp;</span>
        <span>Actions</span>
      </div>
      <div>&nbsp;</div>
      {props.data.length > 0 &&
        props.data.map((item, index) => {
          return (
            <div className="contractList">
              <div className="contractList-value">
                <div className="contractList-name" title={item.contractName}>{item.contractName}</div>
                <div className="contractList-date" title="Contract Start/Contract End">{`( ${moment(
                  item.contractStart
                ).format('MM/DD/YY')} - ${moment(item.contractEnd).format(
                  'MM/DD/YY'
                )} )`}</div>
              </div>
              <button type="button">
                <span
                  disabled={props.selectedIndex === index}
                  className={
                    props.selectedIndex === index
                      ? 'disableLocRow'
                      : 'normalLowRow'
                  }
                  onClick={() => editContract(item, index, 'contract')}
                  id="editContract"
                >
                  Edit
                </span>
                <span onClick={() => viewDocument(item)} id="viewContract">
                  {' '}
                  | View
                </span>
              </button>
            </div>
          );
        })}
    </div>
  );
};

CAContractsList.propTypes = {
  data: instanceOf(Object).isRequired,
};

CAContractsList.defaultProps = {
  data: null,
};

export default CAContractsList;
